import { brand } from '@/shared/config';
import * as s from './ScenarioBanner.css';

interface ScenarioBannerProps {
  /** 단계별 서사 한 문장. 없으면 시작 문장 */
  message?: string;
}

export const ScenarioBanner = ({
  message = '플레이어의 시나리오가 시작됩니다.',
}: ScenarioBannerProps) => (
  <div className={s.scenarioBanner}>
    <div className={s.scenarioBannerLine} />
    <div className={s.scenarioBannerContent}>
      <span className={s.scenarioLabel}>{brand.scenarioTag}</span>
      <span className={s.scenarioMessage}>{message}</span>
    </div>
    <div className={s.scenarioBannerLine} />
  </div>
);
